import type { ButtonConfig } from '../../declare'
import { useContext } from 'react'
import { Button } from 'antd'
import { EasyModal, EasyIcon, FormPage, ListPropsContext } from 'src/components'
import { listStore } from 'src/stores'

type Props = {
  config: ButtonConfig
}

const CustomModalBtn = (props: Props) => {
  const table = listStore.table.get(useContext(ListPropsContext).formCode)

  const handleModalClose = () => {
    table?.reload()
  }

  if (table?.dynamicJs[props.config.CLICK_EVENT] instanceof Function) {
    return table.dynamicJs[props.config.CLICK_EVENT](table, props)
  }

  const { LABEL, ICON, FORM_CODE, WIDTH } = props.config
  return (
    <EasyModal
      modal={{
        title: FORM_CODE,
        width: WIDTH,
        afterClose: handleModalClose,
      }}
      slot={<Button type='primary' icon={<EasyIcon type={ICON} defaultIcon='FormOutlined' />}>{LABEL}</Button>}
    >
      <FormPage formCode={FORM_CODE} />
    </EasyModal>
  )
}

export default CustomModalBtn